import {FC} from 'react'
import {ChooseEmployee} from 'features/procedures/ChooseEmployee'

export const Index: FC = () => {
  return <ChooseEmployee procedureType="start_childcare" nextAction="request" />
}
